import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASEURL, SALESINVOICES } from "./../api/endpoints.js";
import getCookie from "../utils/getCookie.js";

export const salesInvoiceApi = createApi({
  reducerPath: "salesInvoiceApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASEURL}${SALESINVOICES}`,
    prepareHeaders: (headers) => {
      headers.set("Authorization", `Bearer ${getCookie("accessToken")}`);
      return headers;
    },
  }),
  tagTypes: ["SalesInvoice"],
  endpoints: (builder) => ({
    
    // 1. جلب قائمة الفواتير
    getSalesInvoices: builder.query({
      query: (args) => ({
        url: "/GetAll",
        params: {
          "paging.PageNumber": args?.pageNumber || 1,
          "paging.PageSize": args?.pageSize || 10,
        },
      }),
      transformResponse: (response) => {
        // التأكد من الوصول للمصفوفة داخل Response
        if (response?.Response && Array.isArray(response.Response)) {
          return response.Response.map((invoice) => ({
            ...invoice,
            InvoiceDate: invoice.InvoiceDate
              ? new Date(invoice.InvoiceDate).toLocaleDateString("en-CA")
              : null,
          }));
        }
        return [];
      },
      providesTags: (result) =>
        result
          ? [...result.map(({ InvoiceNo }) => ({ type: "SalesInvoice", id: InvoiceNo })), { type: "SalesInvoice", id: "LIST" }]
          : [{ type: "SalesInvoice", id: "LIST" }],
    }),

    // 2. جلب تفاصيل فاتورة محددة (الأسطر فقط)
    getInvoiceDetails: builder.query({
      query: (invoiceNo) => ({
        url: `/GetDetails`,
        params: { invoiceNo } // الأفضل تمريرها كـ params
      }),
      transformResponse: (response) => {
        // بناءً على الـ JSON اللي بعته: Response { Header: {}, Details: [] }
        return response?.Response?.Details || [];
      },
      providesTags: (result, error, invoiceNo) => [{ type: "SalesInvoice", id: invoiceNo }],
    }),

    // 3. جلب الفاتورة كاملة (Header + Details)
    getFullInvoiceData: builder.query({
      query: (invoiceNo) => ({
        url: `/GetDetails`,
        params: { invoiceNo }
      }),
      transformResponse: (response) => {
        return response?.Response || null;
      },
      providesTags: (result, error, invoiceNo) => [{ type: "SalesInvoice", id: invoiceNo }],
    }),

    // Mutations
    addSalesInvoice: builder.mutation({
      query: (data) => ({
        url: "/Insert",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "SalesInvoice", id: "LIST" }],
    }),

    updateSalesInvoice: builder.mutation({
      query: (data) => ({
        url: "/Update",
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result, error, { InvoiceNo }) => [
        { type: "SalesInvoice", id: InvoiceNo },
        { type: "SalesInvoice", id: "LIST" }
      ],
    }),

    deleteSalesInvoice: builder.mutation({
      query: (args) => {
        let invoiceNo = typeof args === "object" ? (args.invoiceNo || args.InvoiceNo) : args;
        return {
          url: `/Delete`,
          method: "POST",
          params: { invoiceNo }
        };
      },
      invalidatesTags: [{ type: "SalesInvoice", id: "LIST" }],
    }),
  }),
});

export const {
  useGetSalesInvoicesQuery,
  useGetInvoiceDetailsQuery,
  useGetFullInvoiceDataQuery,
  useAddSalesInvoiceMutation,
  useUpdateSalesInvoiceMutation,
  useDeleteSalesInvoiceMutation,
} = salesInvoiceApi;